import React, { useContext } from "react";
import { Row, Spinner } from "reactstrap";
import { DF_OT0023Context } from "../context";
import { CardGridCustom } from "../../../../components/Common/CardGridCustom";
import TableSimple from "../../../../components/Dynamic/TableSimple";

export default function GridBody() {
  const { data, isLoading } = useContext(DF_OT0023Context) || {};

  return (
    <CardGridCustom>
      <Row>
        <div 
          className="position-relative w-100" 
          style={{ minHeight: "150px" }}
        >
          {isLoading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 z-index-10">
              <Spinner className="text-primary" size="sm" />
            </div>
          )}

          <div className="w-100 table-sm font-size-13lh-12">
            <TableSimple
              dataKey="Recursos"
              data={data}
              columnsList={[
                {
                  field: "Dias_Expirar_Pre_Agendamento",
                  header: "N.º dias expiração pré agendamento",
                  width: "25%",
                },
                {
                  field: "Dias_Expirar_Agendamento",
                  header: "N.º dias expiração agendamento",
                  width: "25%",
                },
                {
                  field: "Limite_Agendamentos_Diarios_Parceiro",
                  header: "Lim. Agendamento Diário",
                  width: "20%",
                },
                {
                  field: "Recursos",
                  header: "Recursos",
                  width: "15%",
                },
                {
                  field: "Entreposto",
                  header: "Entreposto",
                  width: "15%",
                },
              ]}
              enableMinHeight={true}
            />
          </div>
        </div>
      </Row>
    </CardGridCustom>
  );
}